module.exports = __webpack_public_path__ + "static/media/BusinessCard_03_01.31da7f4a.jpg";